import PulseScope from '@/shared/components/PulseScope/PulseScope'
import PollForm from './PollForm/PollForm'
import PollThanks from './PollThanks/PollThanks'
import useBoardPoll from './useBoardPoll'
import { PollCard, PollQuestion, PollStatus } from './styled-components'

interface BoardPollProps {
  pollKey: string
  question: string
}

const BoardPoll = ({ pollKey, question }: BoardPollProps) => {
  const { title, formHidden, statusHidden, status, form, thanks } = useBoardPoll({ pollKey, question })

  return (
    <PulseScope enabled>
      <PollCard>
        <PollQuestion>{title}</PollQuestion>
        <PollForm {...form} title={title} hidden={formHidden} />
        <PollThanks {...thanks} />
        <PollStatus role='status' hidden={statusHidden}>
          {status}
        </PollStatus>
      </PollCard>
    </PulseScope>
  )
}

export default BoardPoll
